/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  ShadowMCPInventoryServer,
  ShadowMCPInventoryServer$inboundSchema,
} from "./shadowmcpinventoryserver.js";

export type ListShadowMCPInventoryResult = {
  /**
   * Cursor for the next page of results.
   */
  nextCursor?: string | undefined;
  servers: Array<ShadowMCPInventoryServer>;
};

/** @internal */
export const ListShadowMCPInventoryResult$inboundSchema: z.ZodMiniType<
  ListShadowMCPInventoryResult,
  unknown
> = z.pipe(
  z.object({
    next_cursor: z.optional(z.string()),
    servers: z.array(ShadowMCPInventoryServer$inboundSchema),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function listShadowMCPInventoryResultFromJSON(
  jsonString: string,
): SafeParseResult<ListShadowMCPInventoryResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListShadowMCPInventoryResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListShadowMCPInventoryResult' from JSON`,
  );
}
